import styled from 'styled-components/macro'
import { rgba } from '../../utils/styles'

const Separator = styled.hr`
  margin: 1.5em 0;
  border: 0;
  border-bottom: 1px solid ${rgba('base', 0.4)};
`

export default Separator
